import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { Container } from "@/components/atoms";
import { FdaDisclaimer, NewsletterSignup } from "@/components/molecules";
import { Logo } from "./logo";

const columns = [
  {
    title: "Shop",
    links: [
      { label: "All Products", to: "/shop" },
      { label: "Pain Relief", to: "/shop/pain-relief" },
      { label: "Sleep", to: "/shop/sleep" },
      { label: "Topicals", to: "/shop/topical" },
      { label: "For Pets", to: "/shop/pets" },
    ],
  },
  {
    title: "Learn",
    links: [
      { label: "About Dr. Burns", to: "/about" },
      { label: "CBD 101", to: "/cbd-101" },
      { label: "FAQ", to: "/faq" },
      { label: "Contact", to: "/contact" },
    ],
  },
  {
    title: "Support",
    links: [
      { label: "Wholesale", to: "/wholesale" },
      { label: "Shipping", to: "/legal/shipping" },
      { label: "Returns", to: "/legal/returns" },
      { label: "Privacy", to: "/legal/privacy" },
      { label: "Terms", to: "/legal/terms" },
    ],
  },
];

export function Footer() {
  return (
    <footer className="mt-10 bg-night-blue text-white md:mt-16">
      <Container className="grid grid-cols-2 gap-8 py-12 md:grid-cols-5">
        <div className="col-span-2">
          <Logo white />
          <p className="mt-4 max-w-xs text-sm text-white/60">
            Physician-formulated CBD wellness by Dr. Elaine Burns — rooted in
            science, not folklore.
          </p>
          <div className="mt-4 space-y-1 text-sm text-white/70">
            <a
              href="mailto:orders@drburnsreleaf.com"
              className="flex items-center gap-2 hover:text-leaf-green"
            >
              <Mail size={14} /> orders@drburnsreleaf.com
            </a>
          </div>
        </div>

        {columns.map((col) => (
          <div key={col.title}>
            <h4 className="mb-3 font-condensed text-sm font-bold uppercase tracking-wider text-leaf-green">
              {col.title}
            </h4>
            <ul className="space-y-2 text-sm">
              {col.links.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-white/70 hover:text-white">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </Container>

      <Container className="border-t border-white/10 py-6">
        <div className="mb-4 max-w-md">
          <h4 className="mb-2 font-condensed text-sm font-bold uppercase tracking-wider text-leaf-green">
            Stay in touch
          </h4>
          <NewsletterSignup />
        </div>
        <div className="rounded-card bg-white/5 p-4">
          <FdaDisclaimer className="text-white/70" />
        </div>
        <p className="mt-6 text-xs text-white/60">
          {/*
            DRB-4: was "18 or older", which directly contradicted the 21+ gate the visitor had
            just clicked through. Two different minimum ages stated on the same page is worse
            than either one alone — it undermines the gate as a compliance control, because the
            site's own footer says the gate is asking for more than it requires.
          */}
          © {new Date().getFullYear()} DrBurns’ ReLeaf. All rights reserved.
          Must be 21 or older to purchase.
        </p>
      </Container>
    </footer>
  );
}
